/**
 * Offline-aware API wrapper v12.3.0
 * Falls back to IndexedDB queue when offline for POST/PUT requests.
 */
import axios from 'axios';
import { queueOfflineAction, isOnline } from '@/lib/offlineSync';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';

export async function offlinePost(path, data) {
  const url = `${API}${path}`;
  if (isOnline()) {
    return axios.post(url, data);
  }
  await queueOfflineAction(url, 'POST', data);
  toast.info('Saved offline — will sync when connected');
  return { data: { success: true, offline: true } };
}

export async function offlinePut(path, data) {
  const url = `${API}${path}`;
  if (isOnline()) {
    return axios.put(url, data);
  }
  await queueOfflineAction(url, 'PUT', data);
  toast.info('Saved offline — will sync when connected');
  return { data: { success: true, offline: true } };
}
